export default function initializeMap() {

    if ( !document.querySelector('#maposm') ){
        return false;
    }
    console.log('test_2');
        var lat = document.querySelector('#maposm').dataset.lat;
        var lng = document.querySelector('#maposm').dataset.lng;



        var marker_uri = document.querySelector('#maposm').dataset.marker_uri;

        // definiujemy mapę po ID
        var map = L.map('maposm', {dragging: true, trackResize: false}).setView([lat, lng], 17);

        // wyłączamy scroll
        map.scrollWheelZoom.disable();
        // dodajemy szablon mapy
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abc',
            maxZoom: 19,
        }).addTo(map);

        // definiujemy marker
        var icon = L.icon({
            iconUrl: marker_uri,
            shadowUrl: '',

            iconSize:     [36, 48],
            shadowSize:   [0, 0],
            iconAnchor:   [18, 48],
            shadowAnchor: [0, 0],
            popupAnchor:  [-3, -76]
        });

        // dodajemy marker na mapę
        var marker = L.marker([lat, lng], {icon: icon}).addTo(map);


}
